import {
  elFlex,
  elFlexColumn,
  elRowGap1,
  elWFull,
  FlexContainer,
  Icon,
  SecondaryNav,
  SecondaryNavItem,
  Tile,
} from '@reapit/elements'
import React from 'react'
import { css, cx } from '@linaria/core'
import { elSideContiner, elSideNav, elSideNavItems, elTiles } from './style'
import { useNavigate, useParams } from 'react-router'
import { useAgreementState } from '../../use-agreement-state'

export interface IRoutes {
  title: string
  path: string
}
export interface ISideNavigations {
  routes: Array<IRoutes>
}
const SideNavigations: React.FC<ISideNavigations> = (props) => {
  const navigate = useNavigate()
  const { state } = useAgreementState()
  const { sectionId } = useParams()

  const errorsState = state.sectionsError
  const changeRequestState = state.sectionsChangeRequested

  const onNavigate = (routeItem: IRoutes) => () => {
    navigate(`${routeItem.path}`)
  }

  const isActive = (routeItem: IRoutes, index: number): boolean => {
    if (!sectionId && !state.activeMenu) return index === 0
    return state.activeMenu ? state.activeMenu == routeItem.path : sectionId == routeItem.path
  }

  return (
    <FlexContainer {...props} className={cx(elWFull, elSideContiner)}>
      <Tile className={cx(elWFull, elTiles)}>
        <SecondaryNav className={cx(elWFull, elSideNav, elFlex, elFlexColumn, elRowGap1)}>
          {props.routes?.map((routeItem, idx) => (
            <SecondaryNavItem
              key={idx}
              className={cx(elSideNavItems)}
              onClick={onNavigate(routeItem)}
              active={isActive(routeItem, idx)}
            >
              {routeItem.title}
              {Boolean(errorsState?.[idx] || changeRequestState?.[idx]?.length) && (
                <Icon
                  icon="warning"
                  className={css`
                    color: var(--intent-pending) !important;
                  `}
                  width="16px"
                  height="16px"
                />
              )}
            </SecondaryNavItem>
          ))}
        </SecondaryNav>
      </Tile>
    </FlexContainer>
  )
}

export default SideNavigations
